import * as Preact from 'preact';
import QRious from 'qrious';
var generateQrCode = function (url, size) {
    if (size === void 0) { size = 200; }
    return new QRious({ value: url, size: size }).toDataURL();
};
/** Display a QR Code of the specified size for the provided URL */
export var Component = function (p) { return Preact.h("img", { src: generateQrCode(p.url, p.size), alt: "QR Code" }); };
